import StoredLayout from '../../layouts/StoredLayout'
import TableWidgets from './TableWidgets'
export default StoredLayout(TableWidgets)



// WEBPACK FOOTER //
// ./src/widgets/table-widgets/index.js